<template>
    <div class="vm-state" :class="badge.class" :title="badge.label" />
</template>

<script>
const map = {
    'online': {
        label: 'Онлайн',
        class: ['vm-state', 'bg-success']
    },

    'offline': {
        label: 'Не работает',
        class: ['vm-state', 'bg-danger']
    },

    'disconnected': {
        label: 'Нет связи',
        class: ['vm-state', 'bg-secondary']
    },

    'modemless': {
        label: 'Не привязан модем',
        class: ['vm-state', 'bg-primary']
    }
}

export default {
    props: {
        vm: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        state() {
            if (this.vm.modem_id) {
                if (this.vm.state === 1) {
                    return 'online'
                } else if (this.vm.state === 0) {
                    return 'offline'
                } else {
                    return 'disconnected'
                }
            } else {
                return 'modemless'
            }
        },

        badge() {
            return map[this.state]
        }
    }
}
</script>
